module.exports = __webpack_public_path__ + "img/question-square.9c110aa2.svg";